<template>
    <div class="container">
        <Header ref="header"  @backPage="onHome" :title="title"></Header>
        <div class="contract">
            <img src="../../../assets/img/b2b/429@2x.png" width="140" height="140" alt="">
            <p>当前人数过多，请稍等...</p>
            <div class="clickHome" @click="onHome">
                去首页
            </div>
        </div>
    </div>
</template>
<script>
import Header from '../../common/header'
export default {
    name: 'retry',
    components: {
        Header
    },
    data () {
        return {
            height: 0,
            title: '单分享'
        }
    },
    methods: {
        onHome () {
            localStorage.removeItem('tab')
            this.$router.push({ path: '/b2b/home/index' })
        }
    }
}
</script>
<style lang="scss" scoped>
.container {
    height: 100%;
    font-size: 28px;
    overflow: hidden;
}
.contract {
    margin: 0 auto;
    margin-top: 120px;
    text-align: center;
    img {
        margin: 0 auto;
    }
    p {
        color: #888888;
        margin-top: 32px;
    }
    .clickHome {
        width: 328px;
        height: 80px;
        line-height: 80px;
        border-radius: 80px;
        margin: 80px auto;
        text-align: center;
        font-size: 34px;
        background: #FF7A45;
        color: #ffffff;
    }
}
.is-android-top{
    top: 88px;
}
.is-ios-top{
    top: 128px;
}
.is-ios2-top{
    top: 176px;
}
</style>